import React from 'react';
import { financial } from 'utils/number';
import _ from 'lodash';
import { UploadTips } from 'containers/OutWorkbench/ProjectDetail/Show/Detail/Bottom/Making/XiaoHao/utils';
import { UploadFile } from 'modules/types/commons/file';
import {
  FileListShow,
  SelectShow,
  TimeShow,
} from 'containers/OutBidding/components/utils';

export const getFormItemList = (params: any = {}) => {
  const { optionsMap, formData, setFormData, editFields, detail } = params;
  const { bidding_types = [], bidding_methods = [] } = optionsMap;

  const {
    announcement_content_concat,
    bidding_method,
    bidding_type,
    bidding_supplier_num,
    announcement_content,
    bid_proposal_deadline,
    bidding_out_attach_blob_ids,
    bid_registration_deadline,
    bidding_qa_time,
    bidding_qa_attachments,
  } = formData;

  const getUploadConfig = (fileList: any[] = []) => {
    const tmp = {
      componentClass: 'upload',
      showUploadList: { showRemoveIcon: true },
      multiple: true,
      fileList,
      uploadAction: '/api/outsource/v2/java_proxy/attachments/upload',
      onChange({ formItemKey, value }: any) {
        setFormData({
          ...formData,
          [formItemKey]: value.fileList,
        });
      },
      uploadTips: <UploadTips showDownloadTemp={false} />,
      data: (file: UploadFile) => {
        return {
          model: 'V2::Demand',
          filename: file.name,
        };
      },
      showComponent: <FileListShow list={fileList} />,
    };
    return tmp;
  };

  const formList: Record<string, any>[] = [
    // {
    //   key: 'bidding_method',
    //   label: '比选方式',
    //   required: true,
    //   childProps: {
    //     componentClass: 'select',
    //     options: bidding_methods,
    //     value: bidding_method,
    //     showComponent: (
    //       <SelectShow id={bidding_method} options={bidding_methods} />
    //     ),
    //   },
    // },
    // {
    //   key: 'bidding_type',
    //   label: '比选类型',
    //   required: true,
    //   childProps: {
    //     componentClass: 'select',
    //     options: bidding_types,
    //     value: bidding_type,
    //     showComponent: <SelectShow id={bidding_type} options={bidding_types} />,
    //   },
    // },
    // {
    //   key: 'bidding_supplier_num',
    //   label: '比选供应商数量',
    //   required: true,
    //   childProps: {
    //     componentClass: 'inputNumber',
    //     hideHandle: true,
    //     min: 1,
    //     precision: 0,
    //     formatter: (value: number) => financial(value, true),
    //     value: bidding_supplier_num,
    //   },
    // },

    {
      key: 'bid_registration_deadline',
      label: '确认接受比选邀约截止日期',
      required: true,
      childProps: {
        componentClass: 'datePicker',
        value: bid_registration_deadline,
        showComponent: <TimeShow value={bid_registration_deadline} />,
      },
    },
    {
      key: 'bid_proposal_deadline',
      label: '方案提交截止日期',
      required: true,
      childProps: {
        componentClass: 'datePicker',
        value: bid_proposal_deadline,
        showComponent: <TimeShow value={bid_proposal_deadline} />,
      },
    },
    {
      key: 'bidding_qa_time',
      label: '比选答疑日期',
      // required: true,
      childProps: {
        componentClass: 'datePicker',
        value: bidding_qa_time,
        showComponent: <TimeShow value={bidding_qa_time} />,
      },
    },
    {
      key: 'bidding_qa_attachments',
      label: '比选答疑记录',
      childProps: getUploadConfig(bidding_qa_attachments),
    },
    // {
    //   key: 'bidding_out_attach_blob_ids',
    //   label: '比选材料（对外）',
    //   required: true,
    //   childProps: getUploadConfig(bidding_out_attach_blob_ids),
    // },
    // {
    //   key: 'announcement_content',
    //   label: '公告内容',
    //   childProps: {
    //     componentClass: 'textarea',
    //     maxLength: 200,
    //     minHeight: 76,
    //     maxHeight: 200,
    //     value: announcement_content,
    //   },
    // },
    {
      key: 'announcement_content_concat',
      label: '比选公告',
      required: true,
      childProps: {
        componentClass: 'textarea',
        maxLength: 200,
        minHeight: 76,
        maxHeight: 200,
        value: announcement_content_concat,
      },
    },
  ];

  formList.forEach((v) => {
    v.itemColProps = { span: 4 };

    if (['bidding_out_attach_blob_ids'].includes(v.key)) {
      v.itemColProps = { span: 24 };
    }
    if (['announcement_content'].includes(v.key)) {
      v.itemColProps = { span: 24 };
    }
    if (['announcement_content_concat'].includes(v.key)) {
      v.itemColProps = { span: 24 };
    }
    if (v.childProps && !v.childProps.onChange) {
      v.childProps.onChange = ({ formItemKey, value }: any) => {
        const newFormData = _.cloneDeep(formData);
        newFormData[formItemKey] = value;
        setFormData(newFormData);
      };
    }
    if (v.childProps) {
      v.childProps.isShow = true;
    }
    if (editFields.includes(v.key) && v.childProps) {
      v.childProps.isShow = false;
    }
    if (v.key === 'announcement_content_concat') {
      v.childProps.isShow = true;
    }
  });
  return formList;
};
